export enum SortingDirection {
  asc = "ASC",
  desc = "DESC",
}
